import { Component, ViewEncapsulation } from '@angular/core';
import * as _ from 'lodash';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { GridComponent } from '@progress/kendo-angular-grid';
import { BaseGridUIComponent } from '@app/cp/shared/base-components/base-grid-ui.component';
import { SubcoOrderDetail } from '@app/cp/shared/models/SubcoOrderDetail';
import { ConstructionService } from '@app/cp/shared/services/construction.service';
import { InventoryService } from '@app/cp/shared/services/inventory.service';
import { OrderDetailsBus } from '@app/cp/shared/models/OrderDetailsBus';
import { MSCLFilterClass } from '@app/cp/shared/classes/filters/MSCLFilterClass';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { aggregateBy } from '@progress/kendo-data-query';
import { UseFeatureFlagSet, IFeatureFlagSet } from '@app/cp/shared/decorators/featureflags/featureflagset-decorator';

@UseFeatureFlagSet()
@Component({
    selector: 'job-sub-po',
    templateUrl: './job-sub-po.component.html',
    styleUrls: ['./job-sub-po.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class JobSubPOComponent extends BaseGridUIComponent<SubcoOrderDetail, null, ConstructionService>  {

    compFeatureFlagSet: IFeatureFlagSet = this as any;
    supplierCF: MSCLFilterClass;
    svc_inv: InventoryService;
    constructor(globals: GlobalsService, svc_data: ConstructionService, svc_inv: InventoryService) {
    super(globals);
        this.svc_data = svc_data;

        this.aggregates = [
            { field: 'amount', aggregate: 'sum' }
        ];
    }
    showPart(data: SubcoOrderDetail) {
        let tempData: OrderDetailsBus = new OrderDetailsBus(null);
        tempData.inventoryId = data.inventoryBillingCodeId;
        this.svc_inv.partSuppliers.show(tempData);
    }
    processGridData() {
        this.supplierCF = new MSCLFilterClass('supplierName', 'supplierName', this.gridData);
        if (CommonFunctions.hasArrayElementValue(this.gridData)) {
            this.aggregateResults = aggregateBy(this.gridData, this.aggregates);
        }
    }
    groupChange(e: any) {
        console.log("groupChange:", e, this.grid);
        this.collapseAll(this.grid, this.grid.data["data"]);
    }
    collapseAll(grid: GridComponent, items: any[], parentIdentificator: string = undefined, level: number = 1) {
        const self = this;
        items.forEach((item, index) => {
            let fixedIndex = level == 1 ? index + grid.skip : index;
            let identificator = parentIdentificator ? (parentIdentificator + "_" + fixedIndex.toString()) : fixedIndex.toString();

            let isAggregate =  item["aggregates"] && item["field"] && item["items"];

            if (isAggregate) {
                self.collapseAll(grid, item["items"], identificator);
                grid.collapseGroup(identificator);
            }

        });
    }
}
